import {
    User,
} from 'firebase/auth';

export class QontactUser {

    constructor(authUser: User) {
        this.id = authUser.uid
        this.name = authUser.displayName
        this.email = authUser.email
        this.photoURL = authUser.photoURL
    }

    id: string
    name: string
    email: string
    photoURL: string
}

